import api from './api';

export const mediaService = {
    upload: async (file: File, folder: string = '') => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await api.post(`/media/upload${folder ? `?folder=${folder}` : ''}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    },
};
